import { render, staticRenderFns } from "./SignatoryCreateAndEditDialog.vue?vue&type=template&id=48bee88d&scoped=true"
import script from "./SignatoryCreateAndEditDialog.vue?vue&type=script&lang=js"
export * from "./SignatoryCreateAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./SignatoryCreateAndEditDialog.vue?vue&type=style&index=0&id=48bee88d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bee88d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
